import { render, staticRenderFns } from "./_pedidos_abertos.vue?vue&type=template&id=a731a202&scoped=true&"
import script from "./_pedidos_abertos.vue?vue&type=script&lang=js&"
export * from "./_pedidos_abertos.vue?vue&type=script&lang=js&"
import style0 from "./_pedidos_abertos.vue?vue&type=style&index=0&id=a731a202&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a731a202",
  null
  
)

export default component.exports